import { render, staticRenderFns } from "./ExternalDataCard.vue?vue&type=template&id=4244bf0c&"
import script from "./ExternalDataCard.vue?vue&type=script&lang=js&"
export * from "./ExternalDataCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports